import { render, staticRenderFns } from "./ListPushnotes.vue?vue&type=template&id=40481cb7&scoped=true&"
import script from "./ListPushnotes.vue?vue&type=script&lang=js&"
export * from "./ListPushnotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40481cb7",
  null
  
)

export default component.exports